<template>
  <v-row
    align="center"
    justify="center"
    class="no-gutters text-left pa-2 grey lighten-4 green--text"
    v-if="show"
  >
    <v-col class="grow">
      {{messageComputed}}
      <v-chip
        v-for="v,k in filters"
        :key="k"
        label
        color="green lighten-4"
        class="ml-2 mr-2 theme--light pa-0 pl-2"
      >
        <span>{{k}}</span>
        <v-chip label color="green lighten-3 ml-2">{{v.value || v}}</v-chip>
      </v-chip>
    </v-col>
    <v-col class="shrink">
      <v-btn text color="error" :disabled="!this.showClearButton" @click="$emit('clear')">
        <v-icon left>clear</v-icon>clear filters
      </v-btn>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: "AFilterInfo",
  // props: ["message", "filters", "alwaysShow"],
  props: {
    message: String,
    filters: Object,
    alwaysShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showClearButton: function() {
      for (let key in this.filters) {
        if (!this.filters[key].ob) return true
        if (!this.filters[key].ob.notClearable) return true;
      }
      return false;
    },
    messageComputed: function() {
      if (!this.message) {
        if (this.filtersPresent) {
          return "";
        } else {
          return "ALL RECORDS";
        }
      }
      return this.message;
    },
    filtersPresent: function() {
      return this.filters && Object.keys(this.filters).length > 0;
    },
    show: function() {
      return this.alwaysShow || this.filtersPresent;
    }
  },
  methods: {}
};
</script>


<style>
</style>

